import React, {useEffect, useState} from 'react';
import { useAuth } from "react-oidc-context";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import HeaderBar from "./components/HeaderBar";

import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import logo from './logo.svg';

import './App.css';
import {TextField} from "@mui/material";
import SearchComponent from "./components/SearchComponent";

function App() {
    const auth = useAuth();

    return (
      <div className="App">
          <HeaderBar />
          {/* auth weiter übergeben, falls SearchComponent den Token braucht */}
          <SearchComponent auth={auth} />
      </div>
  );
}

export default App;
